import { MeshNode } from './types';
import { mscore } from './utils';

class Mesh {
    static getTreesWithScores(scores, weights, runId, wkey, streamsEnabled): MeshNode[] {
        let treeWithScores = require('./assets/data/mesh_disease_tree.json')
        treeWithScores = this.map(treeWithScores, (node: MeshNode) => (
            {
                ...node,
                mscore: mscore(node.name in scores ? scores[node.name][runId] : null, weights[runId][wkey], streamsEnabled)
            }
        ))
        treeWithScores = this.map(treeWithScores, (node: MeshNode) => (
            {
                ...node,
                children: node.children?.sort((a, b) => b.mscore === null ? -1 : b.mscore - a.mscore || 0)
            }
        ))
        treeWithScores = this.map(treeWithScores, (node: MeshNode) => (
            {
                ...node,
                histData: this.getAllChildrenScores(node)
            }
        ))
        return treeWithScores.children
    }

    private static map(tree: MeshNode, trans: (n: MeshNode) => MeshNode): MeshNode {
        for (let i = 0; i < tree.children?.length || 0; i++)
            tree.children[i] = this.map(tree.children[i], trans);
        return trans(tree)
    }

    private static getAllChildrenScores(targetNode: MeshNode): number[] {
        const result: number[] = [];

        const traverseAndCollect = (node: MeshNode): boolean => {
            if (node.id === targetNode.id) {
                collectAllDescendants(node);
                return true;
            }
            for (const child of node.children || []) {
                if (traverseAndCollect(child)) return true;
            }
            return false;
        };

        const collectAllDescendants = (node: MeshNode): void => {
            result.push(node.mscore || 0);
            for (const child of node.children || []) {
                collectAllDescendants(child);
            }
        };

        traverseAndCollect(targetNode);
        return result;
    }

    static getChildren(parentId: string, trees: MeshNode[]): MeshNode[] {
        const searchNode = (node: MeshNode): MeshNode[] | [] => {
            if (node.id === parentId) {
                return node.children || [];
            }
            for (const child of node.children || []) {
                const result = searchNode(child);
                if (result.length) return result;
            }
            return [];
        };

        for (const tree of trees) {
            const result = searchNode(tree);
            if (result.length) return result;
        }

        return [];
    }

}

export default Mesh;
